import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as _90 from "./accum/v1beta1/accum";
import * as _91 from "./concentrated-liquidity/params";
import * as _92 from "./downtime-detector/v1beta1/downtime_duration";
import * as _93 from "./downtime-detector/v1beta1/genesis";
import * as _94 from "./downtime-detector/v1beta1/query";
import * as _95 from "./epochs/genesis";
import * as _96 from "./epochs/query";
import * as _97 from "./gamm/pool-models/balancer/balancerPool";
import * as _98 from "./gamm/v1beta1/genesis";
import * as _99 from "./gamm/v1beta1/gov";
import * as _100 from "./gamm/v1beta1/query";
import * as _101 from "./gamm/v1beta1/tx";
import * as _102 from "./gamm/pool-models/balancer/tx/tx";
import * as _103 from "./gamm/pool-models/stableswap/stableswap_pool";
import * as _104 from "./gamm/pool-models/stableswap/tx";
import * as _105 from "./gamm/v2/query";
import * as _106 from "./ibc-rate-limit/v1beta1/params";
import * as _107 from "./ibc-rate-limit/v1beta1/query";
import * as _108 from "./incentives/gauge";
import * as _109 from "./incentives/genesis";
import * as _110 from "./incentives/params";
import * as _111 from "./incentives/query";
import * as _112 from "./incentives/tx";
import * as _113 from "./lockup/genesis";
import * as _114 from "./lockup/lock";
import * as _115 from "./lockup/params";
import * as _116 from "./lockup/query";
import * as _117 from "./lockup/tx";
import * as _118 from "./mint/v1beta1/genesis";
import * as _119 from "./mint/v1beta1/mint";
import * as _120 from "./mint/v1beta1/query";
import * as _121 from "./pool-incentives/v1beta1/genesis";
import * as _122 from "./pool-incentives/v1beta1/gov";
import * as _123 from "./pool-incentives/v1beta1/incentives";
import * as _124 from "./pool-incentives/v1beta1/query";
import * as _125 from "./poolmanager/v1beta1/genesis";
import * as _126 from "./poolmanager/v1beta1/module_route";
import * as _127 from "./poolmanager/v1beta1/query";
import * as _128 from "./poolmanager/v1beta1/swap_route";
import * as _129 from "./poolmanager/v1beta1/tx";
import * as _130 from "./protorev/v1beta1/genesis";
import * as _131 from "./protorev/v1beta1/gov";
import * as _132 from "./protorev/v1beta1/params";
import * as _133 from "./protorev/v1beta1/protorev";
import * as _134 from "./protorev/v1beta1/query";
import * as _135 from "./protorev/v1beta1/tx";
import * as _136 from "./sumtree/v1beta1/tree";
import * as _137 from "./superfluid/genesis";
import * as _138 from "./superfluid/params";
import * as _139 from "./superfluid/query";
import * as _140 from "./superfluid/superfluid";
import * as _141 from "./superfluid/tx";
import * as _142 from "./tokenfactory/v1beta1/authorityMetadata";
import * as _143 from "./tokenfactory/v1beta1/genesis";
import * as _144 from "./tokenfactory/v1beta1/params";
import * as _145 from "./tokenfactory/v1beta1/query";
import * as _146 from "./tokenfactory/v1beta1/tx";
import * as _147 from "./twap/v1beta1/genesis";
import * as _148 from "./twap/v1beta1/query";
import * as _149 from "./twap/v1beta1/twap_record";
import * as _150 from "./txfees/v1beta1/feetoken";
import * as _151 from "./txfees/v1beta1/genesis";
import * as _152 from "./txfees/v1beta1/gov";
import * as _153 from "./txfees/v1beta1/query";
import * as _154 from "./valset-pref/v1beta1/query";
import * as _155 from "./valset-pref/v1beta1/state";
import * as _156 from "./valset-pref/v1beta1/tx";
import * as _220 from "./gamm/pool-models/balancer/tx/tx.amino";
import * as _221 from "./gamm/pool-models/stableswap/tx.amino";
import * as _222 from "./gamm/v1beta1/tx.amino";
import * as _223 from "./incentives/tx.amino";
import * as _224 from "./lockup/tx.amino";
import * as _225 from "./poolmanager/v1beta1/tx.amino";
import * as _226 from "./protorev/v1beta1/tx.amino";
import * as _227 from "./superfluid/tx.amino";
import * as _228 from "./tokenfactory/v1beta1/tx.amino";
import * as _229 from "./valset-pref/v1beta1/tx.amino";
import * as _231 from "./gamm/pool-models/balancer/tx/tx.registry";
import * as _232 from "./gamm/pool-models/stableswap/tx.registry";
import * as _233 from "./gamm/v1beta1/tx.registry";
import * as _234 from "./incentives/tx.registry";
import * as _235 from "./lockup/tx.registry";
import * as _236 from "./poolmanager/v1beta1/tx.registry";
import * as _237 from "./protorev/v1beta1/tx.registry";
import * as _238 from "./superfluid/tx.registry";
import * as _239 from "./tokenfactory/v1beta1/tx.registry";
import * as _240 from "./valset-pref/v1beta1/tx.registry";
import * as _242 from "./downtime-detector/v1beta1/query.lcd";
import * as _243 from "./epochs/query.lcd";
import * as _244 from "./gamm/v1beta1/query.lcd";
import * as _245 from "./gamm/v2/query.lcd";
import * as _246 from "./ibc-rate-limit/v1beta1/query.lcd";
import * as _247 from "./incentives/query.lcd";
import * as _248 from "./lockup/query.lcd";
import * as _249 from "./mint/v1beta1/query.lcd";
import * as _250 from "./pool-incentives/v1beta1/query.lcd";
import * as _251 from "./poolmanager/v1beta1/query.lcd";
import * as _252 from "./protorev/v1beta1/query.lcd";
import * as _253 from "./superfluid/query.lcd";
import * as _254 from "./tokenfactory/v1beta1/query.lcd";
import * as _255 from "./twap/v1beta1/query.lcd";
import * as _256 from "./txfees/v1beta1/query.lcd";
import * as _257 from "./valset-pref/v1beta1/query.lcd";
import * as _259 from "./downtime-detector/v1beta1/query.rpc.Query";
import * as _260 from "./epochs/query.rpc.Query";
import * as _261 from "./gamm/v1beta1/query.rpc.Query";
import * as _262 from "./gamm/v2/query.rpc.Query";
import * as _263 from "./ibc-rate-limit/v1beta1/query.rpc.Query";
import * as _264 from "./incentives/query.rpc.Query";
import * as _265 from "./lockup/query.rpc.Query";
import * as _266 from "./mint/v1beta1/query.rpc.Query";
import * as _267 from "./pool-incentives/v1beta1/query.rpc.Query";
import * as _268 from "./poolmanager/v1beta1/query.rpc.Query";
import * as _269 from "./protorev/v1beta1/query.rpc.Query";
import * as _270 from "./superfluid/query.rpc.Query";
import * as _271 from "./tokenfactory/v1beta1/query.rpc.Query";
import * as _272 from "./twap/v1beta1/query.rpc.Query";
import * as _273 from "./txfees/v1beta1/query.rpc.Query";
import * as _274 from "./valset-pref/v1beta1/query.rpc.Query";
import * as _276 from "./gamm/pool-models/balancer/tx/tx.rpc.msg";
import * as _277 from "./gamm/pool-models/stableswap/tx.rpc.msg";
import * as _278 from "./gamm/v1beta1/tx.rpc.msg";
import * as _279 from "./incentives/tx.rpc.msg";
import * as _280 from "./lockup/tx.rpc.msg";
import * as _281 from "./poolmanager/v1beta1/tx.rpc.msg";
import * as _282 from "./protorev/v1beta1/tx.rpc.msg";
import * as _283 from "./superfluid/tx.rpc.msg";
import * as _284 from "./tokenfactory/v1beta1/tx.rpc.msg";
import * as _285 from "./valset-pref/v1beta1/tx.rpc.msg";
import * as _295 from "./lcd";
import * as _296 from "./rpc.query";
import * as _297 from "./rpc.tx";
export let osmosis;

(function (_osmosis) {
  let accum;

  (function (_accum) {
    const v1beta1 = _accum.v1beta1 = _objectSpread({}, _90);
  })(accum || (accum = _osmosis.accum || (_osmosis.accum = {})));

  const concentratedliquidity = _osmosis.concentratedliquidity = _objectSpread({}, _91);

  let downtimedetector;

  (function (_downtimedetector) {
    const v1beta1 = _downtimedetector.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _92), _93), _94), _242), _259);
  })(downtimedetector || (downtimedetector = _osmosis.downtimedetector || (_osmosis.downtimedetector = {})));

  let epochs;

  (function (_epochs) {
    const v1beta1 = _epochs.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _95), _96), _243), _260);
  })(epochs || (epochs = _osmosis.epochs || (_osmosis.epochs = {})));

  let gamm;

  (function (_gamm) {
    const v1beta1 = _gamm.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _97), _98), _99), _100), _101), _222), _233), _244), _261), _278);

    let poolmodels;

    (function (_poolmodels) {
      let balancer;

      (function (_balancer) {
        const v1beta1 = _balancer.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _102), _220), _231), _276);
      })(balancer || (balancer = _poolmodels.balancer || (_poolmodels.balancer = {})));

      let stableswap;

      (function (_stableswap) {
        const v1beta1 = _stableswap.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _103), _104), _221), _232), _277);
      })(stableswap || (stableswap = _poolmodels.stableswap || (_poolmodels.stableswap = {})));
    })(poolmodels || (poolmodels = _gamm.poolmodels || (_gamm.poolmodels = {})));

    const v2 = _gamm.v2 = _objectSpread(_objectSpread(_objectSpread({}, _105), _245), _262);
  })(gamm || (gamm = _osmosis.gamm || (_osmosis.gamm = {})));

  let ibcratelimit;

  (function (_ibcratelimit) {
    const v1beta1 = _ibcratelimit.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _106), _107), _246), _263);
  })(ibcratelimit || (ibcratelimit = _osmosis.ibcratelimit || (_osmosis.ibcratelimit = {})));

  const incentives = _osmosis.incentives = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _108), _109), _110), _111), _112), _223), _234), _247), _264), _279);

  const lockup = _osmosis.lockup = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _113), _114), _115), _116), _117), _224), _235), _248), _265), _280);

  let mint;

  (function (_mint) {
    const v1beta1 = _mint.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _118), _119), _120), _249), _266);
  })(mint || (mint = _osmosis.mint || (_osmosis.mint = {})));

  let poolincentives;

  (function (_poolincentives) {
    const v1beta1 = _poolincentives.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _121), _122), _123), _124), _250), _267);
  })(poolincentives || (poolincentives = _osmosis.poolincentives || (_osmosis.poolincentives = {})));

  let poolmanager;

  (function (_poolmanager) {
    const v1beta1 = _poolmanager.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _125), _126), _127), _128), _129), _225), _236), _251), _268), _281);
  })(poolmanager || (poolmanager = _osmosis.poolmanager || (_osmosis.poolmanager = {})));

  let protorev;

  (function (_protorev) {
    const v1beta1 = _protorev.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _130), _131), _132), _133), _134), _135), _226), _237), _252), _269), _282);
  })(protorev || (protorev = _osmosis.protorev || (_osmosis.protorev = {})));

  let store;

  (function (_store) {
    const v1beta1 = _store.v1beta1 = _objectSpread({}, _136);
  })(store || (store = _osmosis.store || (_osmosis.store = {})));

  const superfluid = _osmosis.superfluid = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _137), _138), _139), _140), _141), _227), _238), _253), _270), _283);

  let tokenfactory;

  (function (_tokenfactory) {
    const v1beta1 = _tokenfactory.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _142), _143), _144), _145), _146), _228), _239), _254), _271), _284);
  })(tokenfactory || (tokenfactory = _osmosis.tokenfactory || (_osmosis.tokenfactory = {})));

  let twap;

  (function (_twap) {
    const v1beta1 = _twap.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _147), _148), _149), _255), _272);
  })(twap || (twap = _osmosis.twap || (_osmosis.twap = {})));

  let txfees;

  (function (_txfees) {
    const v1beta1 = _txfees.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _150), _151), _152), _153), _256), _273);
  })(txfees || (txfees = _osmosis.txfees || (_osmosis.txfees = {})));

  let valsetpref;

  (function (_valsetpref) {
    const v1beta1 = _valsetpref.v1beta1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _154), _155), _156), _229), _240), _257), _274), _285);
  })(valsetpref || (valsetpref = _osmosis.valsetpref || (_osmosis.valsetpref = {})));

  const ClientFactory = _osmosis.ClientFactory = _objectSpread(_objectSpread(_objectSpread({}, _295), _296), _297);
})(osmosis || (osmosis = {}));